import script from "./WorkflowGMP.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowGMP.vue?vue&type=script&setup=true&lang=ts"

import "./WorkflowGMP.vue?vue&type=style&index=0&id=13f20676&lang=scss"

const __exports__ = script;

export default __exports__